import { xpoConfigManagerProvider } from '@xpo-ltl/config-manager';
import { xpoAuthConfigManagerConfiguration } from '@xpo-ltl/ngx-auth';
import { environment } from './environments/environment';
import { translateProvider, LoaderModule } from '@ltl-core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LtlApiStoreModule } from './app/core/ltl-api-store/ltl-api-store.module';
import { provideRouter, withNavigationErrorHandler } from '@angular/router';
import { routes } from './app/app.routes';
import { ServiceWorkerModule } from '@angular/service-worker';
import { isDevMode, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    importProvidersFrom(
      LoaderModule,
      LtlApiStoreModule,
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000',
      })
    ),
    xpoConfigManagerProvider(
      xpoAuthConfigManagerConfiguration({
        firebaseOptions: environment.firebase,
        configFileUrl: './../assets/config.json',
      })
    ),
    translateProvider('en', './../../assets/i18n/'),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideRouter(
      routes,
      withNavigationErrorHandler((error) => {
        console.error('Navigation error:', error);
      })
    )
  ]
}).catch((err) => console.error(err));
